import { Broadcaster } from '@core/app/scripts/services/broadcaster';
import { Mask } from '@core/app/scripts/services/mask';

export class DisplayMessage {
  constructor(
    private $log: ng.ILogService,
    private $rootScope: ng.IRootScopeService,
    private $translate: ng.translate.ITranslateService,
    private broadcaster: Broadcaster,
    private mask: Mask,
  ) {}

  /**
   * Function which handles the message object
   * @param {String|Object} _options Supports an options object or a string message as a parameter
   * @param {String} message the message to display
   * @param {String} type the message type (alert, info, error, prompt, errorprompt)
   * @param {Boolean} [ok] display an ok button or yes/no button (only used in combination with prompt/errorprompt)
   * @param {Function} [callback] an optional callback to be executed after the message is displayed
   * @param {Boolean} [mini] an optional flag to use the smaller message UI
   */
  message = (_options) => {
    if (angular.isString(_options)) {
      _options = {
        message: _options,
        type: 'alert',
        callback: null,
        mini: false,
      };
    }
    if (!angular.isObject(_options)) {
      this.$log.error(
        '[displayMessage] Parameter must be type String or Object!',
        _options,
      );
      return;
    }

    if (_options.mini) {
      //mini messaging offers unobtrusive non-garanteed delivery: it just overwrites older versions of itself
      this.broadcaster.send('displayMiniMessage', _options);
    } else {
      let body = '<br>' + _options.message + '<br>';
      if (
        _options.type !== undefined &&
        (_options.type == 'prompt' || _options.type == 'errorprompt')
      ) {
        if (_options.ok) {
          //Display only an OK dialog
          body =
            body +
            '<div class="display-message__buttons"><button id="OkButton" class="v6-btn">' +
            this.$translate.instant('OK') +
            '</button></div>';
        } else {
          //Display a yes/no dialog
          body =
            body +
            '<div class="display-message__buttons"><button id="YesButton" data-test="yesButton" class="v6-btn yes v6-btn-inline-wide">' +
            this.$translate.instant('Yes') +
            '</button><button id="NoButton" data-test="noButton" class="v6-btn no v6-btn-inline-wide">' +
            this.$translate.instant('No') +
            '</button></div>';
        }
        if (_options.cancel !== undefined) {
          body =
            body +
            '<div class="display-message__buttons"><button id="CancelButton" class="v6-btn">' +
            this.$translate.instant('Cancel') +
            '</button></div>';
        }
      }
      //Update the body
      _options.message = body;
      const guid = this.generateRandom();
      //Save the message to the current rootScope
      // @ts-ignore
      if (!this.$rootScope.dialogMessage) {
        // @ts-ignore
        this.$rootScope.dialogMessage = {};
      }
      // @ts-ignore
      this.$rootScope.dialogMessage[guid] = _options;

      //Broadcast to the dialogMessage directive to show the message
      this.broadcaster.send('displayMessage', guid);
    }
  };

  showLoading = () => {
    this.mask.showLoading();
  };

  hideLoading = () => {
    this.mask.hide();
  };

  generateRandom = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
}

/*
 * Handles error and prompt messages to the user. The dialogMessage directive
 * handles the display of the message in the view
 */
angular
  .module('v6CoreModule')
  .factory(
    'displayMessage',
    ($log, $rootScope, translate, broadcaster, mask) => {
      return new DisplayMessage($log, $rootScope, translate, broadcaster, mask);
    },
  );
